import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopPay(props) {
  const {open, close} = props;
  const [selectedOption, setSelectedOption] = useState('rdoState01');
  return (
    <Modal open={open} close={close} type="pop_pay com_pay">
		 {/* 20250218 퍼블 수정&추가 */}
      <h2 className="pop_tit">결제하기</h2>
      <div className="content_container scroll">
        <section className="com_board_search">
          <article className="search">
            <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input xs type_search" />
            <button className="com_btn gray ws xs icon_search"></button>
          </article>
        </section>

        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <span className="tit">학생명</span>
              <span className="cont">홍학생103</span>
            </div>
            <div className="info">
              <span className="tit">담임</span>
              <span className="cont">홍담임103</span>
            </div>
            <div className="info">
              <span className="tit">미입금 금액</span>
              <span className="cont">3회 ㅣ 4657,000</span>
            </div>
          </div>
          <div className="com_radio_wrap padding_y center">
            <input type="radio" name="rdo_pay" id="rdo_pay_01" className="com_chk circle" checked={selectedOption === 'rdoState01'} onChange={() => setSelectedOption('rdoState01')} />
            <label htmlFor="rdo_pay_01">결제</label>
            <input type="radio" name="rdo_pay" id="rdo_pay_02" className="com_chk circle" checked={selectedOption === 'rdoState02'} onChange={() => setSelectedOption('rdoState02')} />
            <label htmlFor="rdo_pay_02">결제방법 변경</label>
            <input type="radio" name="rdo_pay" id="rdo_pay_03" className="com_chk circle" checked={selectedOption === 'rdoState03'} onChange={() => setSelectedOption('rdoState03')} />
            <label htmlFor="rdo_pay_03">결제취소</label>
          </div>
        </div>
        {selectedOption === 'rdoState01' && (
          <>
            {/* 결제선택시 */}
            <div className="com_board_box">
              <div className="board_wrap">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <p className="cont">결제할 금액 입력</p>
                  <div className="input_wrap">
                    <input type="text" className="input  com_blue_txt" defaultValue={`450,000`} />
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <div className="board_wrap">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <p className="cont">결제할 금액 입력</p>
                  <div className="input_wrap">
                    <input type="text" className="input  com_blue_txt" defaultValue={`450,000`} />
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <hr className="com_divider" />
              <div className="board_item">
                <div className="info">
                  <span className="tit">총 결제할 금액</span>
                  <span className="cont">478,000</span>
                </div>
                <div className="info">
                  <span className="tit">결제 총 회차</span>
                  <span className="cont">3.4</span>
                </div>
                <div className="info">
                  <span className="tit">할인 금액</span>
                  <span className="cont">12,000</span>
                </div>
                <div className="info">
                  <span className="tit">실 결제 금액</span>
                  <span className="cont com_blue_txt">450,000</span>
                </div>
              </div>
            </div>
            <div className="com_red_txt">
              * 3개월 선 결제시 할인
              <br />* DC 할인 내역이 있을 경우 할인되지 않습니다.
            </div>
            <div className="detail_tit dot">결제 방법 선택</div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="130" />
                <col width="auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th>카드 (단말기)</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <select name="" id="" className="select">
                        <option value="할부 개월">할부 개월</option>
                      </select>
                    </div>
                    <div className="com_input_wrap">
                      <select name="" id="" className="select">
                        <option value="카드사 명">카드사 명</option>
                      </select>
                    </div>
                    <div className="com_input_wrap">
                      <input type="text" className="input" placeholder="카드번호" />
                      <input type="text" className="input ws" placeholder="승인번호" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>카드 결제</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />

                      <input type="text" className="input" placeholder="승인번호" />
                      <span className="com_check_box">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">월별 자동결제</label>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>가상계좌 입금</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <div className="com_bk_txt">하나은행 : 134141-324174-23154</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>현금 입금</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <span className="com_check_box">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">현금영수증</label>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="btn_container">
              <button className="com_btn orange xs">결제하기</button>
            </div>
          </>
        )}
        {selectedOption === 'rdoState02' && (
          <>
            {/* 결제변경 선택시 */}
            <div className="pay_list">
              <div className="check">
                {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                  return (
                    <div className="check_item" key={idx}>
                      <input type="radio" name="rdo_list" id={`rdo_list_${idx}`} className="com_chk circle" />
                      <label htmlFor={`rdo_list_${idx}`}>2023,05,10ㆍ5회ㆍ750,000ㆍ홍길동ㆍ(카드)ㆍ하나카드1132-3221-32131</label>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_wrap">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <p className="cont">결제할 금액 입력</p>
                  <div className="input_wrap">
                    <input type="text" className="input  com_blue_txt" defaultValue={`450,000`} />
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <div className="board_wrap">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    {/* 20250218 퍼블 수정&추가 */}
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <p className="cont">결제할 금액 입력</p>
                  <div className="input_wrap">
                    <input type="text" className="input  com_blue_txt" defaultValue={`450,000`} />
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">총 결제할 금액</span>
                  <span className="cont">478,000</span>
                </div>
                <div className="info">
                  <span className="tit">결제 총 회차</span>
                  <span className="cont">3.4</span>
                </div>
                <div className="info">
                  <span className="tit">할인 금액</span>
                  <span className="cont">12,000</span>
                </div>
                <div className="info">
                  <span className="tit">실 결제 금액</span>
                  <span className="cont com_blue_txt">450,000</span>
                </div>
              </div>
            </div>
            <div className="detail_tit dot">결제 방법 선택</div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="130" />
                <col width="auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th>날짜</th>
                  <td>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </td>
                </tr>
                <tr>
                  <th>카드 (단말기)</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <select name="" id="" className="select">
                        <option value="할부 개월">할부 개월</option>
                      </select>
                    </div>
                    <div className="com_input_wrap">
                      <select name="" id="" className="select">
                        <option value="카드사 명">카드사 명</option>
                      </select>
                    </div>
                    <div className="com_input_wrap">
                      <input type="text" className="input" placeholder="카드번호" />
                      <input type="text" className="input ws" placeholder="승인번호" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>카드 결제</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />

                      <input type="text" className="input" placeholder="승인번호" />
                      <span className="com_check_box">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">월별 자동결제</label>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>가상계좌 입금</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <div className="com_bk_txt">하나은행 : 134141-324174-23154</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>현금 입금</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws blue" defaultValue={`15,000`} />
                      <span className="com_check_box">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">현금영수증</label>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_red_txt">* 실 결제한 금액과 동일하게 결제금액을 입력해 주세요.</div>
            <div className="btn_container">
              <button className="com_btn orange xs">저장</button>
            </div>
          </>
        )}
        {selectedOption === 'rdoState03' && (
          <>
            {/* 결제취소 선택시 */}
            <div className="pay_list">
              <div className="check">
                {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                  return (
                    <div className="check_item" key={idx}>
                      <input type="radio" name="rdo_list" id={`rdo_list_${idx}`} className="com_chk circle" />
                      <label htmlFor={`rdo_list_${idx}`}>2023,05,10ㆍ5회ㆍ750,000ㆍ홍길동ㆍ(카드)ㆍ하나카드1132-3221-32131</label>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_wrap">
                <div className="board_item item_with_check">
                  <div className="check_pos">
                    <input type="checkbox" name="chk" id="itemchk_01" className="com_chk" />
                    <label htmlFor="itemchk_01"></label>
                  </div>
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <div className="info">
                    <span className="tit">결제한 금액</span>
                    <span className="cont com_blue_txt">450,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <div className="board_wrap">
                <div className="board_item item_with_check">
                  <div className="check_pos">
                    <input type="checkbox" name="chk" id="itemchk_02" className="com_chk" />
                    <label htmlFor="itemchk_02"></label>
                  </div>
                  <div className="info">
                    <span className="tit">과목</span>
                    <span className="cont">국어</span>
                  </div>
                  <div className="info">
                    <span className="tit">할인</span>
                    <span className="cont">형제할인 2%</span>
                  </div>
                  <div className="info">
                    <span className="tit">상품가격</span>
                    <span className="cont">480,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">진행한 수업</span>
                    <span className="cont">12/16</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사103</span>
                  </div>
                  <div className="info">
                    <span className="tit">입금된 회차 / 금액</span>
                    <span className="cont price com_blue_txt">3회 / 300,000</span>
                  </div>
                </div>
                <div className="board_item bg_blue">
                  <div className="info">
                    <span className="tit">결제한 금액</span>
                    <span className="cont com_blue_txt">450,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">결제 회차:</span>
                    <span className="cont price">3.4</span>
                  </div>
                </div>
              </div>
              <hr className="com_divider" />
              <div className="board_item">
                <div className="info">
                  <span className="tit">총 결제할 금액</span>
                  <span className="cont">478,000</span>
                </div>
                <div className="info">
                  <span className="tit">결제 총 회차</span>
                  <span className="cont">3.4</span>
                </div>
                <div className="info">
                  <span className="tit">할인 금액</span>
                  <span className="cont">12,000</span>
                </div>
                <div className="info">
                  <span className="tit">실 결제 금액</span>
                  <span className="cont com_blue_txt">450,000</span>
                </div>
              </div>
            </div>

            <div className="detail_tit dot">결제 취소 금액</div>
            <div className="com_info center">
              <p className="name">총 환불 금액 (취소 금액) : 450,000</p>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="130" />
                <col width="auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    환불 계좌
                      {/*<input type="checkbox" name="chk" id="chk010" className="com_chk" />
                      <label for="chk010">직접입력</label>*/}
                  </th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <select name="" id="" className="select">
                        <option value="은행 선택">은행 선택</option>
                      </select>
                    </div>
                    <div className="com_input_wrap">
                      <input type="text" className="input ws" placeholder="계좌주 입력" />
                      <input type="text" className="input " placeholder="계좌 번호 입력" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>상세 사유 입력 </th>
                  <td className="td_left">
                    <input type="text" className="input" placeholder="입력" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="btn_container">
              <button className="com_btn orange xs">저장</button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default PopPay;
